export default __webpack_public_path__ + "static/media/chatbot1.cf034321.svg";